import type { ComponentProps, ReactNode } from "react";

import { cx } from "./cx";

/** Empty is a kind: a status line with nothing wrong to say still holds its height. */
export type StatusKind = "" | "ok" | "warn" | "err";

export interface StatusLineProps extends Omit<ComponentProps<"div">, "children"> {
  kind?: StatusKind;
  children?: ReactNode;
}

const KIND: Record<StatusKind, string> = {
  "": "",
  ok: "text-ok",
  // The text-safe amber: the graphic warn colour is for fills, and as letters on paper it
  // stops clearing AA.
  warn: "text-warn-ink font-medium",
  err: "text-danger font-medium",
};

/**
 * The one place each screen says what just happened.
 *
 * `aria-live="polite"` and the reserved line height are the same decision from two
 * directions: the line is announced without stealing focus, and it holds its row so a
 * message arriving does not shove the button out from under somebody's thumb.
 */
export function StatusLine({ kind = "", className, ...rest }: StatusLineProps) {
  return (
    <div
      className={cx("mt-4 text-note min-h-status-line", KIND[kind], className)}
      aria-live="polite"
      {...rest}
    />
  );
}
